module.exports = ".btn-mine{\r\n    border: 1px solid #17a2b8;\r\n}\r\n.btn-group .btn{\r\n    min-width: 5px;\r\n}\r\n.btn-group i{  \r\n    color: white;\r\n}\r\n.small-icon img{\r\n    width: 30px;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component.css
// module id = ./src/app/Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component.css
// module chunks = main